export default "__VITE_ASSET__BXhPCyAj__"